// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/core." + {"645":"p2p","654":"trader"}[chunkId] + "." + {"645":"75fc774daba7970253f1","654":"3cd287464bbd3df383c2"}[chunkId] + ".js";
};